import * as React from 'react';
import { UserLink, CopyablePhone } from 'components';
import './referral-infos.scss';
import { Page } from 'components/page/page';
import { Card } from 'components/card/card';
import { Table } from 'components/table/table';
import { ReferralInfo } from 'core/domain';
import { CopyOutlined, ExportOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { getAllReferralInfos } from 'core/repositories/referral';
import { Button, buttonType } from 'components/button/button';
import { Input } from 'components/input/input';
// import { ClientSidePagination } from "components/pagination/pagination";
import { Enum, PaginationList } from '../../../../core/domain/commons/common';
import moment from 'jalali-moment';
import { getPageNum } from 'core/utils/paggingHelper';
import { copyToClipboard } from 'core/utils/copyToClipboard';
import DatePicker from 'react-multi-date-picker';
import persian from 'react-date-object/calendars/persian';
import persian_fa from 'react-date-object/locales/persian_fa';
import { ReactComponent as CalendarIcon } from 'assets/icons/dash-line-icons/calendar.svg';
import { faNumToEnNum } from 'core/utils/decimalExtentions';
import { downloadCSV } from '../../../../core/utils/export-to-file';
import { digitSperator } from 'core/utils/decimalExtentions';
import { jFormat } from 'core/utils/jFormat';
import { getViaAuth, responseValidator } from 'apis/api';
import { API } from 'apis';
import { Dropdown } from 'components/dropdown/dropdown';

interface FilterValues {
    search: string;
    startDate: string;
    endDate: string;
    sortDirection?: Enum;
}

const empty_filters = {
    search: '',
    startDate: '',
    endDate: '',
    sortDirection: {
        id: 0,
        title: 'همه مرتب‌سازی‌ها',
    },
};

export const ReferralInfos: React.FC = () => {
    var itemsPerPageCount = 20;

    const referralInfoLevels = [
        {
            id: 0,
            title: 'همه',
        },
        {
            id: 1,
            title: 'پایه',
        },
        {
            id: 2,
            title: 'نقره ای',
        },
        {
            id: 3,
            title: 'طلایی',
        },
    ];

    const defaultLevelSelected = {
        id: 0,
        title: 'سطح کاربر را انتخاب کنید',
    };

    const defaultSelectedSortDirection: Enum = {
        id: 0,
        title: 'همه مرتب‌سازی‌ها',
    };

    const [referralInfos, setReferralInfos] = React.useState<PaginationList<ReferralInfo>>();
    const [loading, setLoading] = React.useState<boolean>(false);
    const [buttonLoading, setButtonLoading] = React.useState<boolean>(false);
    const [query, setQuery] = React.useState<string>('');
    const [deleteButtonLoading, setDeleteButtonLoading] = React.useState<boolean>(false);
    const [pageEnd, setPageEnd] = React.useState(10);
    const [sortDirections, setSortDirections] = React.useState<Enum[]>([defaultSelectedSortDirection]);
    const [filterValues, setFilterValues] = React.useState<FilterValues>(empty_filters);
    const [pageSize, setPageSize] = React.useState<number>(10);

    const navigate = useNavigate();
    const startDateRef = React.useRef(null);
    const endDateRef = React.useRef(null);

    const filterHandle = (clearFilter?: boolean) => {
        var _query = '';

        if (filterValues.search !== '') _query += `${_query.includes('?') ? '&' : '?'}keywords=${filterValues.search}`;
        if (filterValues.sortDirection.id !== 0)
            _query += `${_query.includes('?') ? '&' : '?'}sortDirection=${filterValues.sortDirection.id}`;
        if (filterValues.startDate !== '')
            _query += `${_query.includes('?') ? '&' : '?'}startDate=${jFormat(filterValues.startDate)}`;
        if (filterValues.endDate !== '')
            _query += `${_query.includes('?') ? '&' : '?'}endDate=${jFormat(filterValues.endDate)}`;

        setQuery(_query);
        getAllReferralInfos(
            clearFilter ? setDeleteButtonLoading : _query !== '' ? setButtonLoading : setLoading,
            setReferralInfos,
            getPageNum(),
            pageSize,
            clearFilter ? '' : _query,
        );
    };

    const clearFiltersHandle = () => {
        setFilterValues(empty_filters);
        filterHandle(true);
    };

    React.useEffect(() => {
        setLoading(true);
        getViaAuth(API.enum.referralInfoSortDirection)
            .then((response: any) => {
                setLoading(false);
                if (responseValidator(response.status) && response.value) {
                    setSortDirections([{ id: 0, title: 'همه مرتب‌سازی‌ها' }, ...response.value]);
                }
            })
            .finally(() => setLoading(false));
        getAllReferralInfos(setLoading, setReferralInfos, getPageNum(), pageSize);
    }, []);

    const columns: any[] = [
        {
            name: 'کد دعوت',
            id: 'code',
            selector: (row: ReferralInfo) => row.code,
            width: '11%',
            cell: (row: ReferralInfo) => (
                <span className="en copiable">
                    {row?.code}
                    <CopyOutlined onClick={() => copyToClipboard(row.code, 'کد دعوت')} />
                </span>
            ),
        },
        {
            name: 'نام کامل',
            id: 'fullName',
            selector: (row: ReferralInfo) => row.fullName,
            cell: (row: ReferralInfo) => <UserLink userId={row.userId}>{row.fullName || '-'}</UserLink>,
            width: '12%',
        },
        {
            name: 'موبایل',
            id: 'phoneNumber',
            selector: (row: ReferralInfo) => row.phoneNumber,
            cell: (row: ReferralInfo) => (
                <CopyablePhone phoneNumber={row.phoneNumber} />
            ),
            width: '11%',
        },
        {
            name: 'موجودی (تومانی)',
            id: 'irtBalance',
            selector: (row: ReferralInfo) => digitSperator(row.irtBalance),
            width: '8%',
            cell: (row: ReferralInfo) => <span>{row.irtBalance != null ? digitSperator(row.irtBalance) : '-'}</span>,
        },
        {
            name: 'موجودی کل (تومانی)',
            id: 'totalBalanceIRT',
            selector: (row: ReferralInfo) => digitSperator(row.totalBalanceIRT),
            width: '8%',
            cell: (row: ReferralInfo) => (
                <span>{row.totalBalanceIRT != null ? digitSperator(row.totalBalanceIRT) : '-'}</span>
            ),
        },
        {
            name: 'موجودی (TRX)',
            id: 'trxBalance',
            selector: (row: ReferralInfo) => digitSperator(row.trxBalance),
            width: '8%',
            cell: (row: ReferralInfo) => <span>{row.trxBalance != null ? digitSperator(row.trxBalance) : '-'}</span>,
        },
        {
            name: 'موجودی کل (TRX)',
            id: 'totalBalanceTRX',
            selector: (row: ReferralInfo) => digitSperator(row.totalBalanceTRX),
            width: '8%',
            cell: (row: ReferralInfo) => (
                <span>{row.totalBalanceTRX != null ? digitSperator(row.totalBalanceTRX) : '-'}</span>
            ),
        },
        {
            name: 'کاربران',
            id: 'userCount',
            selector: (row: ReferralInfo) => row.userCount,
            width: '8%',
            cell: (row: ReferralInfo) => <span>{row.userCount ?? 0}</span>,
        },
        {
            name: 'کاربران احراز‌شده',
            id: 'authenticatedUsersCount',
            selector: (row: ReferralInfo) => row.authenticatedUsersCount,
            width: '8%',
            cell: (row: ReferralInfo) => <span>{row.authenticatedUsersCount ?? 0}</span>,
        },
        {
            name: 'احراز سطح1',
            id: 'authenticatedUsersLevel1Count',
            selector: (row: ReferralInfo) => row.authenticatedUsersLevel1Count,
            width: '8%',
            cell: (row: ReferralInfo) => <span>{row.authenticatedUsersLevel1Count ?? 0}</span>,
        },
        {
            name: 'احراز سطح2',
            id: 'authenticatedUsersLevel2Count',
            selector: (row: ReferralInfo) => row.authenticatedUsersLevel2Count,
            width: '8%',
            cell: (row: ReferralInfo) => <span>{row.authenticatedUsersLevel2Count ?? 0}</span>,
        },
        {
            name: 'سفارش‌ها (جمع)',
            id: 'sumOrder',
            selector: (row: ReferralInfo) => digitSperator(row.sumOrder),
            width: '12%',
            cell: (row: ReferralInfo) => <span>{row.sumOrder != null ? digitSperator(row.sumOrder) : '-'}</span>,
        },
        {
            name: 'تاریخ ایجاد',
            id: 'createdOn',
            selector: (row: ReferralInfo) => row?.createdOn || '',
            sortable: true,
            cell: (row: ReferralInfo) => (
                <span>
                    {row?.createdOn
                        ? moment.utc(row.createdOn).locale('fa').local().format('YYYY/MM/DD') +
                          ' ' +
                          moment.utc(row.createdOn).locale('fa').local().format('HH:mm')
                        : ''}
                </span>
            ),
            width: '12%',
        },
        {
            name: 'آخرین ویرایش',
            id: 'lastModifiedDate',
            selector: (row: ReferralInfo) => row?.lastModifiedDate || '',
            cell: (row: ReferralInfo) => (
                <span>
                    {row?.lastModifiedDate
                        ? moment.utc(row.lastModifiedDate).locale('fa').local().format('YYYY/MM/DD HH:mm')
                        : ''}
                </span>
            ),
            width: '12%',
        },
    ];

    return (
        <Page className="pmx-referral-infos" title="همکاران ما">
            <Card title="لیست همکاران" blur={loading}>
                <div className="filter-row">
                    <div className="fields">
                        <Input
                            value={filterValues.search}
                            className="search"
                            placeholder="جستجو کنید ..."
                            onPressEnter={filterHandle}
                            name="search"
                            onChange={(e) => setFilterValues({ ...filterValues, search: e.target.value })}
                        />
                        {sortDirections.length > 0 && (
                            <Dropdown
                                items={sortDirections}
                                onChangeHandle={(value) =>
                                    setFilterValues({
                                        ...filterValues,
                                        sortDirection: sortDirections.find((l) => l.id === value),
                                    })
                                }
                                selectedOption={filterValues.sortDirection}
                            />
                        )}
                        <DatePicker
                            className="date-picker"
                            value={filterValues.startDate}
                            calendar={persian}
                            ref={startDateRef}
                            locale={persian_fa}
                            render={
                                <div>
                                    <Input
                                        value={filterValues.startDate}
                                        icon={<CalendarIcon />}
                                        placeholder="از تاریخ"
                                    />
                                </div>
                            }
                            onChange={(e) => {
                                setFilterValues({ ...filterValues, startDate: e.format() });
                            }}
                        />
                        <DatePicker
                            className="date-picker"
                            value={filterValues.endDate}
                            calendar={persian}
                            ref={endDateRef}
                            locale={persian_fa}
                            render={
                                <div>
                                    <Input
                                        value={filterValues.endDate}
                                        icon={<CalendarIcon />}
                                        placeholder="تا تاریخ"
                                    />
                                </div>
                            }
                            onChange={(e) => {
                                setFilterValues({ ...filterValues, endDate: e.format() });
                            }}
                        />
                    </div>
                    <div className="buttons">
                        <Button
                            loading={buttonLoading}
                            disabled={buttonLoading}
                            text="اعمال فیلتر"
                            type={buttonType.success}
                            onClick={() => filterHandle()}
                        />
                        <Button
                            loading={deleteButtonLoading}
                            disabled={deleteButtonLoading}
                            text="حذف فیلتر"
                            type={buttonType.error}
                            onClick={clearFiltersHandle}
                        />
                        <Button
                            text="خروجی اکسل"
                            type={buttonType.info}
                            icon={<ExportOutlined />}
                            onClick={(event) => downloadCSV('referrals', referralInfos.items)}
                        />
                    </div>
                </div>
                {referralInfos?.items && referralInfos?.items.length > 0 && (
                    <>
                        <Table
                            setPageSize={setPageSize}
                            blur={loading}
                            setloader={setLoading}
                            getdata={getAllReferralInfos}
                            setdata={setReferralInfos}
                            pagination={referralInfos.pagination}
                            className="referral-infos-table"
                            data={referralInfos.items}
                            column={columns}
                            filters={query}
                        />
                    </>
                )}
            </Card>
        </Page>
    );
};
